import IconHide from '@apollo/icons/default/IconHide.svg';
import { Badge } from '@apollo/orbit';
import React from 'react';

import { Tooltip } from 'src/components/common/tooltip/Tooltip';

export const HiddenBadge = () => (
  <Tooltip label="Your graph is hidden from other members of this organization unless they are added to the graph or are an Org Admin.">
    <Badge className="ml-2" icon={<IconHide />}>
      Hidden
    </Badge>
  </Tooltip>
);
